// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__32gFZ","col":"Table_col__283lJ","fulfillmentStatus":"Table_fulfillmentStatus__jL9Hb","emailCol":"Table_emailCol__2MidR"};